import { render, staticRenderFns } from "./KeepingStatistics.vue?vue&type=template&id=0c529604&scoped=true&"
import script from "./KeepingStatistics.vue?vue&type=script&lang=js&"
export * from "./KeepingStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c529604",
  null
  
)

export default component.exports